var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"bg-danger"},[_vm._v("DO NOT USE MEMBERSEARCHFIELD")])
}
var staticRenderFns = []

export { render, staticRenderFns }